import { Button, Group, Modal, Stack } from '@mantine/core';
import type { TProject } from '@newo/api/gateway';
import MDEditor from '@/components/MDEditor';

interface ProjectReadmeModalProps {
    project?: TProject;
    onClose: () => void;
    onEdit: () => void;
}

const ProjectReadmeModal = ({
    project,
    onClose,
    onEdit
}: ProjectReadmeModalProps) => {
    return (
        <Modal
            opened={!!project}
            size="70%"
            title={project ? `${project.title} - Readme` : 'Readme'}
            onClose={onClose}
        >
            <Stack className="p-1" gap="md">
                <MDEditor
                    hideToolbar
                    preview="preview"
                    value={project?.readme ?? ''}
                />
                <Group justify="flex-end">
                    <Button size="xs" onClick={onEdit}>
                        Edit
                    </Button>
                </Group>
            </Stack>
        </Modal>
    );
};

export default ProjectReadmeModal;
